import { Text } from "@overmap-ai/blocks"
import { memo } from "react"

import { EMPTY_COLUMN_FALLBACK } from "../constants"

export const EmptyColumnCellFallback = memo(() => {
	return (
		<Text accentColor="base" weight="light">
			{EMPTY_COLUMN_FALLBACK}
		</Text>
	)
})
EmptyColumnCellFallback.displayName = "EmptyColumnCellFallback"
